import {DynamicFormRestService} from './restServices';
import storageService from '../storageService';

var service = {};

service.createAndUpateDynamicFormTemplate = async (formTemplateObj, token) => {
  var newFormTemplateObj = {
    ...formTemplateObj,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await DynamicFormRestService.save(
    {
      endpoint: '',
    },
    newFormTemplateObj,
  );
  return response.data;
};
service.getDynamicFormTemplateByMentorId = async (formType, mentorId) => {
  const response = await DynamicFormRestService.get(
    {
      endpointParam: formType,
      endpointParam2: mentorId,
    },
    null,
  );
  return response.data;
};

service.deleteDynamicFormTemplate = async (
  dynamicFormTemplateId,
  mentorUserId,
  token,
) => {
  const _token = token ? token : storageService.getItem('token');
  const response = await DynamicFormRestService.delete(
    {
      endpointParam: mentorUserId,
      endpointParam2: `${dynamicFormTemplateId}/?token=${_token}`,
    },
    null,
  );
  return response.data;
};

const dynamicFormService = {...service};
export default dynamicFormService;
